import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {SliceStatus} from 'interfaces'
import {SettingsState} from './settingsSlice'

const getSettings = (state: RootState): SettingsState => {
  return state.settings
}

export const selectUserGroupDetails = createSelector(
  getSettings,
  settings => settings?.userGroupDetails || {},
)

export const selectSettingsUsers = createSelector(getSettings, data => data)

export const selectUserGroupList = createSelector(
  selectSettingsUsers,
  settings => settings.usersGroupsList,
)

export const selectUserGroupDetailsLoading = createSelector(
  selectUserGroupDetails,
  details => details.status === SliceStatus.pending,
)
